import * as React from 'react'
import { ComponentExt } from 'util/reactExt'
import { Modal, Tabs } from 'antd'
import { inject, observer } from 'mobx-react'
import styles from './index.scss'
import { taskType } from 'constants/index'
import ConfigContentEditZone from 'containers/views/Levelup/ConfigContentEditZone'
import ConfigContentLibrary from 'containers/views/Levelup/ConfigContentLibrary'

const TabPane = Tabs.TabPane
const contentList = [
  {
    key: taskType.example,
    name: '题目管理',
  },
  {
    key: taskType.video,
    name: '视频管理',
  },
]

interface IConfigContentModalProps {
  levelStore?: any
}

interface IConfigContentModalState {}

export enum SubTabKeys {
  EDIT_ZONE = 'editZone',
  LIBRARY = 'library',
}

@inject('globalStore', 'levelStore')
@observer
export default class ConfigContentModal extends ComponentExt<
  IConfigContentModalProps,
  IConfigContentModalState
> {
  state = {
    currentSubTabKey: SubTabKeys.EDIT_ZONE as SubTabKeys,
  }

  subTabRef = null

  constructor(props) {
    super(props)
    this.subTabRef = React.createRef()
  }

  toggleConfigContentVisible = (): void => {
    const {
      levelStore: {
        toggleConfigContentVisible,
        configContentVisible,
        setConfigContentList,
      },
    } = this.props
    if (configContentVisible) {
      setConfigContentList({ data: [], total: 0 })
      this.switchSubTab(SubTabKeys.EDIT_ZONE)
    }
    toggleConfigContentVisible()
  }

  switchTab = (key: string): void => {
    const {
      levelStore: { toggleConfigContentPanel, setCurrentConfigContent },
    } = this.props

    toggleConfigContentPanel(key)
    this.switchSubTab(SubTabKeys.EDIT_ZONE)
    setCurrentConfigContent(null)
  }

  switchSubTab = (key: SubTabKeys): void => {
    const {
      levelStore: {
        setCurrentConfigContent,
        getConfigContentList,
        currentConfigContentType,
      },
    } = this.props
    const { currentSubTabKey } = this.state
    const mode =
      currentConfigContentType === taskType.video ? 'video' : 'example'
    this.setState({
      currentSubTabKey: key,
    })

    if (currentSubTabKey === SubTabKeys.EDIT_ZONE) {
      setCurrentConfigContent(null)
      getConfigContentList({}, mode)

      if (this.subTabRef.resetForm) {
        this.subTabRef.resetForm()
      }
    }
  }

  onRef = ref => {
    this.subTabRef = ref
  }

  render() {
    const {
      levelStore: {
        configContentVisible,
        currentConfigContentType,
        configContentMode,
      },
    } = this.props
    const { currentSubTabKey } = this.state
    const subTabName =
      currentConfigContentType === taskType.example ? '题目' : '视频'
    const subTabs = [
      {
        key: SubTabKeys.EDIT_ZONE,
        name: `${configContentMode}${subTabName}`,
        component: ConfigContentEditZone,
      },
      {
        key: SubTabKeys.LIBRARY,
        name: `${subTabName}库`,
        component: ConfigContentLibrary,
      },
    ]

    return (
      <Modal
        width={1000}
        footer={null}
        onCancel={this.toggleConfigContentVisible}
        visible={configContentVisible}
      >
        <Tabs
          onChange={this.switchTab}
          activeKey={currentConfigContentType}
          defaultActiveKey={contentList[0].key}
        >
          {contentList.map(content => (
            <TabPane tab={content.name} key={content.key}>
              <Tabs
                defaultActiveKey={subTabs[0].key}
                onChange={this.switchSubTab}
                activeKey={currentSubTabKey}
                tabPosition={'left'}
              >
                {subTabs.map(subTab => (
                  <TabPane tab={subTab.name} key={subTab.key}>
                    <subTab.component
                      currentTab={currentSubTabKey}
                      onRef={this.onRef}
                      toggleSubTab={this.switchSubTab}
                    />
                  </TabPane>
                ))}
              </Tabs>
            </TabPane>
          ))}
        </Tabs>
      </Modal>
    )
  }
}
